import { Injectable } from '@angular/core';
import type { ReportDescriptorInterface } from '@zaoblako/shared/common/dtos/report/report-descriptor.dto';
import type { ExternalUserLkPageInterface } from '@zaoblako/shared/modules/security/dtos/external-user/lk/external-user-lk-page.dto';
import type { ExternalUserFindInterface } from '@zaoblako/shared/modules/security/dtos/external-user/external-user-find.dto';
import type { ExternalUserInviteOneQueryInterface } from '@zaoblako/shared/modules/security/dtos/external-user/external-user-invite-one-query.dto';
import type { ExternalUserLkQueryInterface } from '@zaoblako/shared/modules/security/dtos/external-user/lk/external-user-lk-query.dto';
import type { CardDescriptorInterface } from '@zaoblako/shared/common/dtos/card/card-descriptor.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PersonalAccountExternalUserService extends BaseService {
  protected baseUrl = '/personal-account/security/external-user';

  public getReportDescriptor(): Observable<ReportDescriptorInterface> {
    return this.http.get<ReportDescriptorInterface>(this.baseUrl);
  }

  public getCardDescriptor(): Observable<CardDescriptorInterface> {
    return this.http.get<CardDescriptorInterface>(`${this.baseUrl}/card-descriptor`);
  }

  public findWithPagination(queryParams: ExternalUserLkQueryInterface): Observable<ExternalUserLkPageInterface> {
    return this.http.get<ExternalUserLkPageInterface>(`${this.baseUrl}/items`, {
      params: this.objectToHttpParams(queryParams)
    });
  }

  public inviteOne(id: number, params?: ExternalUserInviteOneQueryInterface): Observable<void> {
    return this.http.get<void>(`${this.baseUrl}/${id}/invite`, {
      params: params ? this.objectToHttpParams(params) : {}
    });
  }

  public ban(id: number): Observable<ExternalUserFindInterface> {
    return this.http.post<ExternalUserFindInterface>(`${this.baseUrl}/${id}/ban`, null);
  }

  public unban(id: number): Observable<ExternalUserFindInterface> {
    return this.http.post<ExternalUserFindInterface>(`${this.baseUrl}/${id}/unban`, null);
  }
}
